import type { TracksFilters } from '~/modules/artist-roster/pages/artist-details/utils/types';

export const DEFAULT_RELEASES_FILTERS: TracksFilters = {
  searchText: undefined,
  releaseType: undefined,
  role: undefined,
};
